<template>
  <qtm-input-label v-if="formats.length > 0" label="PO Format" :required="!disabled">
    <qtm-select
      :disabled="props.disabled"
      :error-messages="errors.modelValue"
      hide-details="auto"
      :model-value="modelValue"
      item-title="name"
      :items="formats"
      @update:model-value="$emit('update:model-value', $event)"
    />
  </qtm-input-label>
</template>

<script setup lang="ts">
import { requiredIf } from '@vuelidate/validators'
import useValidation from '@/composables/validation'
import usePoNumberFormats from '@/composables/po-number-formats'

export interface Props {
  company?: number
  disabled?: boolean
  modelValue?: number | null
}

const props = defineProps<Props>()
const emit = defineEmits(['update:model-value'])

const { errors, isValid } = useValidation({
  rules: { modelValue: { required: requiredIf(() => !props.disabled && formats.value.length > 0) } },
  state: toRefs(props),
})

const { fetchFormats, formats } = usePoNumberFormats(props.company)

watch(() => props.company, () => fetchFormats(props.company))

const stopWatch = watchEffect(() => {
  if (!props.disabled && !props.modelValue && formats.value.length > 0) {
    emit('update:model-value', formats.value.find(format => format.is_default)?.id ?? null)
    stopWatch()
  }
})

defineExpose({ isValid })
</script>
